var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.293L13.1464 2.14645C13.3417 1.95118 13.6583 1.95118 13.8536 2.14645C14.0366 2.3295 14.0481 2.61919 13.8879 2.81558L13.8536 2.85355L8.707 8L13.8536 13.1464C14.0366 13.3295 14.0481 13.6192 13.8879 13.8156L13.8536 13.8536C13.6705 14.0366 13.3808 14.0481 13.1844 13.8879L13.1464 13.8536L8 8.707L2.85355 13.8536C2.6705 14.0366 2.38081 14.0481 2.18442 13.8879L2.14645 13.8536C1.96339 13.6705 1.95195 13.3808 2.11212 13.1844L2.14645 13.1464L7.293 8L2.14645 2.85355C1.96339 2.6705 1.95195 2.38081 2.11212 2.18442L2.14645 2.14645C2.3295 1.96339 2.61919 1.95195 2.81558 2.11212L2.85355 2.14645L8 7.293Z",
    fill: "#006FCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7a63a746a782156908ef6e6d3cf05197.svg";
export { ForwardRef as ReactComponent };